module.exports = __webpack_public_path__ + "img/join-bg.323539f3.png";